import React from 'react';
import './LoadingIndicator.css';

const LoadingIndicator = () => {
  return <div className="loading-indicator"></div>;
};

export default LoadingIndicator;